import FilePickerErrorMessageType, {
    errorMessageMap,
    FilePickerErrorMessage,
} from '../types/FilePickerErrorMessageType';
import { observer } from 'mobx-react';
import { trace } from 'owa-trace';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./FilePickerErrorMessageView.scss');

export interface FilePickerErrorMessageViewProps {
    message: FilePickerErrorMessageType;
}

@observer
export default class FilePickerErrorMessageView extends React.Component<
    FilePickerErrorMessageViewProps,
    {}
> {
    constructor(props: FilePickerErrorMessageViewProps) {
        super(props);
    }

    private getErrorMessage = function getErrorMessage(
        message: FilePickerErrorMessageType
    ): FilePickerErrorMessage {
        if (message in errorMessageMap) {
            return errorMessageMap[message]();
        }

        trace.error('invalid errorMessageType given. Showing generic error message');
        return errorMessageMap[FilePickerErrorMessageType.Generic]();
    };

    render() {
        const errorMessage = this.getErrorMessage(this.props.message);

        return (
            <div className={styles.container}>
                <span className={classNames(errorMessage.icon, styles.emptyStateIcon)} />
                <div className={styles.emptyStateMessage}> {errorMessage.message} </div>
                {errorMessage.messageSubtext && (
                    <div className={styles.emptyStateMessageSubtext}>
                        {' '}
                        {errorMessage.messageSubtext}{' '}
                    </div>
                )}
            </div>
        );
    }
}
